import { render, staticRenderFns } from "./TrailerDetailsWidget.vue?vue&type=template&id=3a89ed10&"
import script from "./TrailerDetailsWidget.vue?vue&type=script&lang=js&"
export * from "./TrailerDetailsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TrailerDetailsWidget.vue?vue&type=style&index=0&id=3a89ed10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TrailerDetailsWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports